import { useCurrentAccountQuery } from '~/generated/graphql';

export default function useCurrentAccount() {
  const { data, loading, refetch } = useCurrentAccountQuery();

  return {
    account: data?.account,
    loading,
    refetch,
  };
}
